module.exports = __webpack_public_path__ + "img/dataAnalysis.01b4e82b.png";